module.exports = __webpack_public_path__ + "img/00005.3a52b695.webp";